import _every from 'lodash/every';
import _map from 'lodash/map';
import { useMemo } from 'react';
import Stack from '../../../_components/Stack';
import { Button } from '../../Button';
import { FeaturedIcon } from '../../FeaturedIcon';
import CustomStepper from '../components/CustomStepper';
import EmptyStateDescription from '../components/EmptyStateDescription';
import EmptyStateTitle from '../components/EmptyStateTitle';
import { containerVariants, titleVariants } from '../styles';
import type { EmptyStateAsStepProps } from '../types';

function EmptyStateAsStep(props: EmptyStateAsStepProps) {
  const { title, description, Icon, steps, buttons, variant, learnMore } = props;
  const containerClassName = containerVariants({ variant });
  const titleClassName = titleVariants({ variant });
  const allStepsCompleted = useMemo(
    () => _every(steps, (step) => step.isCompleted || step.isOptional),
    [steps],
  );

  return (
    <Stack
      alignItems="start"
      className={containerClassName}
      direction="column"
      justifyContent="end"
    >
      <Stack className="border-tertiary gap-y-2xl pb-xl w-full border-b">
        {Icon ? <FeaturedIcon color="gray" Icon={Icon} size="md" /> : null}
        <Stack>
          <EmptyStateTitle className={titleClassName} title={title} />
          {description ? (
            <EmptyStateDescription description={description} learnMore={learnMore} />
          ) : null}
        </Stack>
      </Stack>
      <CustomStepper steps={steps} />
      {buttons.length ? (
        <Stack className="gap-x-lg pt-2xl" direction="row">
          {_map(buttons, (button, index) => {
            return (
              <Button
                color="brand"
                disabled={!allStepsCompleted}
                key={`${button.label} ${index}`}
                size="md"
                variant="solid"
                {...button}
              >
                {button.label}
              </Button>
            );
          })}
        </Stack>
      ) : null}
    </Stack>
  );
}

export default EmptyStateAsStep;
